import { Skeleton } from "@/shared/ui";

export default function BankingPageSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <Skeleton height={100} className="rounded-2xl" />

      <div className="grid grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="radius-lg border surface-base-stroke surface-base-fill p-4">
            <div className="flex items-center gap-2 mb-2">
              <Skeleton circle width={32} height={32} />
              <Skeleton height={14} width={80} />
            </div>
            <Skeleton height={24} width={150} />
          </div>
        ))}
      </div>

      <div className="flex items-end gap-3">
        <div className="flex-1">
          <Skeleton height={40} />
        </div>
        <Skeleton height={40} width={192} />
        <Skeleton height={40} width={256} />
      </div>

      <div className="flex flex-col gap-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="radius-lg border surface-base-stroke surface-base-fill p-4">
            <div className="flex items-center gap-4">
              <Skeleton circle width={40} height={40} />
              <div className="flex-1">
                <Skeleton height={16} width={200} className="mb-2" />
                <Skeleton height={14} width={150} />
              </div>
              <Skeleton height={20} width={120} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
